<!-- Header -->
<div class="container-full head">
  <div class="container">
    <div class="columns">
      <div class="column is-12-desktop">
        <app-breadcrumbs
          [darkTheme]="true"
          [breadcrumbLinks]="breadcrumbLinks"
        ></app-breadcrumbs>
        <h1 i18n="@@aboutAIWonkTitle" class="title is-1 has-text-light">
          The AI Wonk
        </h1>
        <p i18n="@@aboutAIWonkSubtitle">
          Not all intelligence is artificial. Keep yours real with the AI Wonk
          blog.
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Main content -->
<div class="container m-t-alt">
  <div class="columns flex flex-wrap">
    <div
      class="column is-12-mobile is-12-tablet is-7-desktop p-r-gap-desktop m-b-gutter"
    >
      <!-- large layout -->
      <app-post-card
        [post]="mainFeaturedPost"
        [layout]="PostLayout.Large"
        *ngIf="mainFeaturedPost"
      ></app-post-card>

      <div *ngIf="loadingFeaturedPosts" class="lc lc--large">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      class="column is-12-mobile is-12-tablet is-5-desktop flex flex-column card--post--small m-b-gutter"
    >
      <!-- small layouts -->
      <div *ngFor="let post of otherFeaturedPosts">
        <app-post-card [post]="post" [layout]="PostLayout.List"></app-post-card>
      </div>

      <div *ngIf="loadingFeaturedPosts" class="lc lc--list">
        <div class="lc-list__top-item"></div>
        <div></div>
        <div></div>
      </div>
      <div *ngIf="loadingFeaturedPosts" class="lc lc--list">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div *ngIf="loadingFeaturedPosts" class="lc lc--list">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>

  <div class="columns">
    <div class="column is-12-desktop">
      <div class="card card--contributors bg-white">
        <div class="columns flex-touch wrap-touch">
          <div class="column is-5-desktop is-12-touch">
            <div class="card card--contributors__infos is-full-height">
              <h3 i18n="@@aboutAboutAIWonkTitle">About the AI Wonk</h3>
              <p i18n="@@aboutAboutAIWonkText">
                The AI Wonk is a space where the
                <a routerLink="/network-of-experts"
                  >OECD Network of Experts on AI (ONE AI)</a
                >
                and guest contributors share their experiences and research. It
                is an ongoing conversation about
                <a routerLink="/ai-principles">the OECD AI Principles</a>
                and how to best share and shape trustworthy AI policies that
                benefit individuals, communities and economies.
              </p>
            </div>
          </div>
          <div class="column is-12-touch is-7-desktop p-y-lg p-x-gutter">
            <div class="columns">
              <div class="column is-12-desktop">
                <div class="flex space-between align-center m-b-gutter">
                  <h3
                    i18n="@@aboutAIWonkContributorsTitle"
                    class="title is-3 has-text-black m-b-0"
                  >
                    OECD.AI Community
                  </h3>
                  <div>
                    <a
                      i18n="@@aboutAIWonkContributorsViewMore"
                      routerLink="/community"
                      class="ghost"
                      >View all community
                      <span class="m-l-md square bg-link"
                        ><i class="icon icon-Addlarge has-text-white"></i></span
                    ></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns flex flex-wrap">
              <div
                class="column is-6-mobile is-4-tablet is-4-desktop"
                *ngFor="let author of authors"
              >
                <app-author-card
                  [author]="author"
                  [authorImage]="author.image"
                ></app-author-card>
              </div>
              <div
                class="column is-6-mobile is-4-tablet is-4-desktop"
                *ngIf="loadingAuthors"
              >
                <div class="lc lc--author">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div
                class="column is-6-mobile is-4-tablet is-4-desktop"
                *ngIf="loadingAuthors"
              >
                <div class="lc lc--author">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div
                class="column is-6-mobile is-4-tablet is-4-desktop"
                *ngIf="loadingAuthors"
              >
                <div class="lc lc--author">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <form novalidate [formGroup]="postForm">
    <div class="columns is-multiline m-t-gutter">
      <div class="column is-12 py-0">
        <span class="is-uppercase">Filters</span>
      </div>
      <div class="column is-12-mobile is-6-tablet is-3-desktop">
        <div class="control full-width">
          <label for="stakeholderTypeSelect">By stakeholder type</label>
          <div class="select">
            <select
              class="p-b-0"
              id="stakeholderTypeSelect"
              formControlName="stakeholderTypeId"
              (change)="filterPosts('stakeholderTypeId', $event.target.value)"
            >
              <option i18n="@@aboutAIWonkStakeholderOption" value="" selected>
                All stakeholder types
              </option>
              <option
                [value]="stakeholderType.id"
                *ngFor="let stakeholderType of stakeholderTypes"
              >
                {{ stakeholderType.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="column is-12-mobile is-6-tablet is-3-desktop">
        <div class="control full-width">
          <label for="aiPrincipleSelect">By AI principle</label>
          <div class="select">
            <select
              class="p-b-0"
              id="aiPrincipleSelect"
              formControlName="aiPrincipleId"
              (change)="filterPosts('aiPrincipleId', $event.target.value)"
            >
              <option i18n="@@aboutAIWonkAIPrincipleOption" value="" selected>
                All AI principles
              </option>
              <option
                [value]="aiPrinciple.id"
                *ngFor="let aiPrinciple of aiPrinciples"
              >
                {{ aiPrinciple.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="column is-12-mobile is-12-tablet is-6-desktop is-relative">
        <div class="control">
          <label for="blog-search-input">Search by title or content</label>
        </div>
        <span
          class="icon is-small is-right pointer close-button"
          *ngIf="searchEl.nativeElement.value"
          (click)="filterPosts('terms', '')"
          (keydown)="filterPosts('terms', '')"
          tabindex="0"
          id="blog-search-input"
        >
          <i class="fas fa-times has-text-primary"></i>
        </span>
        <p class="control has-icons-left has-icons-right my-0">
          <input
            class="input"
            type="search"
            id="blog-search-input"
            placeholder="Search posts by title or content..."
            i18n-placeholder="@@blogIndexPlaceholderSearch"
            #searchInput
          />
          <span class="icon is-small is-left">
            <i class="fas fa-search has-text-grey-dark"></i>
          </span>
        </p>
      </div>
    </div>
  </form>

  <!-- Post list -->
  <div class="columns m-t-gutter">
    <div class="column is-12-desktop">
      <h2 i18n="@@aboutAIWonkLatestPostsTitle" class="title is-2 mb-2">
        Latest posts
      </h2>
    </div>
  </div>
  <div class="columns flex flex-wrap">
    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngIf="!loadingPosts && postPaginator && !postPaginator.data.length"
    >
      <p i18n="@@aboutAIWonkNoPostFound">No post found with those filters.</p>
    </div>

    <ng-container *ngIf="postPaginator">
      <div
        class="column is-12-mobile is-6-tablet is-4-desktop"
        *ngFor="let post of postPaginator.data"
      >
        <app-post-card [post]="post"></app-post-card>
      </div>
    </ng-container>

    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngIf="loadingPosts"
    >
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngIf="loadingPosts"
    >
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngIf="loadingPosts"
    >
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngIf="loadingPosts"
    >
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngIf="loadingPosts"
    >
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngIf="loadingPosts"
    >
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>

  <app-pagination
    [paginator]="postPaginator"
    *ngIf="postPaginator"
    (pageChange)="goToPage($event)"
  ></app-pagination>

  <!-- Document list -->
  <app-document-list
    [documents]="documents"
    *ngIf="documents && documents.length"
  ></app-document-list>

  <app-author-disclaimer></app-author-disclaimer>
</div>
